// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"e36d71a8","977":"f7e7a39e"}[chunkId] + ".chunk.js";
};